import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ShieldCheck } from "lucide-react";

const STORAGE_KEY = "bananax_age_verified_v1";

export default function AgeGate() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const verified = localStorage.getItem(STORAGE_KEY);
    if (!verified) setOpen(true);
  }, []);

  const confirm = () => {
    localStorage.setItem(STORAGE_KEY, "1");
    setOpen(false);
  };

  const deny = () => {
    window.location.href = "https://www.google.com";
  };

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5 }}
          className="fixed inset-0 z-[100] flex items-center justify-center"
          style={{ background: "rgba(11,10,10,0.92)", backdropFilter: "blur(30px)" }}
          data-testid="age-gate-modal"
        >
          <motion.div
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.2, duration: 0.6 }}
            className="relative w-[min(560px,92vw)] bg-ink-900 border border-white/10 px-10 py-14 text-center"
          >
            <div className="grain-overlay"></div>
            <div className="flex justify-center mb-6">
              <ShieldCheck className="w-10 h-10 text-gold stroke-[1.2]" />
            </div>
            <div className="label-eyebrow mb-4">Discretion Confirmed</div>
            <h2 className="font-serif text-4xl md:text-5xl tracking-tight leading-tight mb-4">
              Are you of <span className="text-gradient-gold italic">legal age</span>?
            </h2>
            <p className="text-mist text-sm leading-relaxed max-w-sm mx-auto mb-10 font-light">
              BananaX is an intimate wellness collection intended for adults. Please confirm
              that you are 18 years or older to enter.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <button onClick={confirm} className="btn-primary" data-testid="age-gate-confirm">
                I am 18 or older
              </button>
              <button onClick={deny} className="btn-ghost" data-testid="age-gate-deny">
                Exit site
              </button>
            </div>
            <p className="mt-8 text-[10px] tracking-[0.3em] uppercase text-mist/60">
              By entering you agree to our terms & privacy policy
            </p>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
